<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6" :offset="0">
        <div style="border: 1px solid #c5d0e2; border-radius: 2px; padding: 16px">
          <div style="display: flex; align-items: center; font-size: 12px">
            <div style="color: #0f1a3a; font-weight: bold">
              {{ $t("videom.realvideovehicllist") }}
            </div>
            <div style="color: #0f1a3a; flex: 1; text-align: right">
              <span class="online"></span>
              {{ $t("vehicle.online") }}
              <span class="offline"></span>
              {{ $t("vehicle.offline") }}
            </div>
          </div>
          <div style="
              border: 1px solid #a2b1cb;
              border-radius: 2px;
              padding: 8px;
              margin-top: 8px;
            ">
            <div>
              <el-input size="small" v-model="searchkey" :placeholder="$t('videom.plsinput')" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div style="height: calc(100vh - 450px); overflow-y: auto">
              <el-tree :data="treedata" :props="defaultProps" ref="tree" highlight-current show-checkbox
                :filter-node-method="filterNode">
                <div style="" slot-scope="{ node, data }">
                  <div @contextmenu.prevent="onContextmenu($event, data)" class="v_tree_node"
                    :class="data.OnlineState != 0 ? 'v_online' : 'v_offline'">
                    <i class="icon_camera"></i>{{ data.CarNo }}
                  </div>
                </div>
              </el-tree>
            </div>
            <div>
              <div style="padding: 16px; background: #fff">
                <el-checkbox-group v-model="channelList">
                  <el-checkbox :label="1">{{ $t("videom.channel") }}1</el-checkbox>
                  <el-checkbox :label="2">{{ $t("videom.channel") }}2</el-checkbox>
                  <el-checkbox :label="3">{{ $t("videom.channel") }}3</el-checkbox>
                  <el-checkbox :label="4">{{ $t("videom.channel") }}4</el-checkbox>
                  <el-checkbox :label="5">{{ $t("videom.channel") }}5</el-checkbox>
                  <el-checkbox :label="6">{{ $t("videom.channel") }}6</el-checkbox>
                  <el-checkbox :label="7">{{ $t("videom.channel") }}7</el-checkbox>
                  <el-checkbox :label="8">{{ $t("videom.channel") }}8</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div style="margin-top: 16px">
            <el-row :gutter="12">
              <el-col :span="12">
                <div class="btn_monitor" @click="startVedioMonitor">
                  <i class="icon_start_monitor"></i>{{ $t("videom.startMonitor") }}
                </div>
              </el-col>
              <el-col :span="12">
                <div class="btn_monitor" @click="stopVedioMonitor">
                  <i class="icon_stop_monitor"></i>{{ $t("videom.stopMonitor") }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="18" :offset="0">
        <div style="
            border: 1px solid #c5d0e2;
            border-radius: 2px;
            height: calc(100vh - 200px);
          ">
          <KLVideo :showToolBar="true" ref="klvideo" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import KLVideo from "@/components/KLVideo/index"; //
 
import { mapState } from "vuex";
export default {
  components: { KLVideo },

  watch: {
    searchkey(val) {
      this.$refs.tree.filter(val);
    },
  },
  computed: {
    ...mapState({
      vehicles: (state) => state.app.vehicles,
    }),
    // treedata() {
    //   if (this.vehicles) {
    //     //只显示车辆
    //     var t = this.vehicles.data.filter((item) => item.treeLevel == 5); //[0]; //.filter((item) => item.treeLevel == 5);
    //     return t;
    //   }
    //   return [];
    // },
    size() {
      return this.$store.getters.size;
    },
  },
  data() {
    return {
      treedata: [],
      channelList: [1, 2, 3, 4],
      searchkey: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },

  methods: {
    onContextmenu(event, data) {
      //右键菜单，设备不在线要不要处理
      // if(data.isOnLine == 0){
      //  return false;
      // }
      this.$contextmenu({
        items: [
          {
            label: this.$t("videom.startMonitor"),
            onClick: () => {
              this.startSingleVehicleMonitor(data.DeviceNo, data.CarNo);
            },
          },
          {
            label: this.$t("videom.stopMonitor"),
            onClick: () => {
              this.$refs.klvideo.CloseVideoBySimNum(data.DeviceNo);
            },
          },
        ],
        event,
        //x: event.clientX,
        //y: event.clientY,
        // customClass: "custom-class",
        zIndex: 3,
        minWidth: 130,
      });
      return false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.CarNo.indexOf(value) !== -1;
    },

    stopVedioMonitor() {
      var v_list = this.$refs.tree.getCheckedNodes();

      if (v_list.length == 0) {
        //提示，请选中需要监控的车辆
        this.$message({
          message: this.$t("videom.pleaseMonitorVehicle"),
          type: "warning",
        });
        return;
      }

      v_list.forEach((element) => {
        this.$refs.klvideo.CloseVideoBySimNum(element.DeviceNo);
      });
    },

    startSingleVehicleMonitor(deviceNo, vehicleName) {
      //启动单车监控
      let index = 0;
      let timer = setInterval(() => {
        if (index < this.channelList.length) {
          this.$refs.klvideo.SetWait(
            deviceNo,
            parseInt(this.channelList[index]),
            vehicleName
          );
          index++;
        } else {
          // 停止定时器
          clearInterval(timer);
        }
      }, 500);
    },
    startVedioMonitor() {
      //监控流程，选中一个车辆

      var v_list = this.$refs.tree.getCheckedNodes();

      if (v_list.length == 0) {
        //提示，请选中需要监控的车辆
        this.$message({
          message: this.$t("videom.pleaseMonitorVehicle"),
          type: "warning",
        });
        return;
      }
      if (this.channelList.length == 0) {
        this.$message({
          message: this.$t("videom.plsselectchannel"),
          type: "warning",
        });
        return;
      }

      // v_list.forEach(element => {
      //   this.startSingleVehicleMonitor(
      //     element.DeviceNo,
      //     element.CarNo
      //     );
      // });

      let index = 0;
      let timer = setInterval(() => {
        if (index < v_list.length) {

          // this.startSingleVehicleMonitor(
          //  "004010003229",
          //  "公交"
          // );
          //测试
          // this.startSingleVehicleMonitor(
          //  "004011000035",// "004014001293",
          //   "测试"
          // );
          //正式
          this.startSingleVehicleMonitor(
            v_list[index].DeviceNo,
            v_list[index].CarNo
          );

          index++;
        } else {
          // 停止定时器
          clearInterval(timer);
        }
      }, this.channelList.length * 500);
    },
    queryVideoDeviceNo() {
     this.$api.queryVideoDeviceNoByOptID().then(res => {
        if (res.code == 200) {
          this.treedata = res.data;
        }
      })
    }
  },
  mounted() {
    // console.log(this.treedata);
    //获取treedata
    this.queryVideoDeviceNo();
  },
  beforeDestroy() { },
  created() { },
};
</script>
<style scoped>
.btn_monitor {
  display: flex;
  align-items: center;
  background: #2a7aff;
  border-radius: 2px;
  height: 32px;

  font-size: 12px;
  color: #ffffff;
  flex-direction: row;
  justify-content: center;
  cursor: pointer;
}

.v_tree_node {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.v_tree_node>i {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  background-size: cover;
  display: inline-block;
}

.v_online {
  color: #0F1A3A;
}

.v_offline {
  color: #A2B1CB;
}

.offline {
  background: #A2B1CB !important;
  width: 10px;
  height: 10px;
  display: inline-block;
}

.online {
  background: #0F1A3A !important;
  width: 10px;
  height: 10px;
  display: inline-block;
}

.v_offline>.icon_camera {
  background-image: url("~@/assets/images/icon_shexiangtou_hui.png");
}

.v_online>.icon_camera {
  background-image: url("~@/assets/images/icon_shexiangtou_hei.png");
}

.icon_start_monitor {
  width: 20px;
  height: 20px;
  margin-right: 4px;

  display: inline-block;
  background-image: url("~@/assets/images/icon_kaishijiankong.png");
}

.icon_stop_monitor {
  width: 20px;
  height: 20px;
  margin-right: 4px;
  display: inline-block;
  background-image: url("~@/assets/images/icon_jieshujiankong.png");
}

.el-checkbox {
  margin-right: 16px !important;
}
</style>
